import React from 'react'
import {KTSVG} from '../KTSVG'

interface ButtonTypes {
  type?: any
  className?: any
  onClick?: () => void
  iconPath?: any
  iconClass?: string
  children?: any
  disabled?: any
}
const WSButton = ({
  type,
  className,
  onClick,
  iconPath,
  iconClass,
  children,
  disabled,
}: ButtonTypes) => {
  return (
    <button type={type} className={className} onClick={onClick} disabled={disabled}>
      <KTSVG path={iconPath} className={iconClass} />
      {children}
    </button>
  )
}

export default WSButton
